export default "__VITE_ASSET__CyJ8qn7T__"